import React, { useEffect } from 'react';
import { Alert, Typography, Upload, Button, Space } from 'antd';
import { InboxOutlined, DeleteOutlined } from '@ant-design/icons';
import { useAppDispatch } from 'app/config/store';
import { reset } from '../uploads.reducer';

const { Dragger } = Upload;
const { Title } = Typography;

interface FileUploadProps {
  selectedFile: File | null;
  setSelectedFile: (file: File | null) => void;
  parseExcelFile: (file: File) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({ selectedFile, setSelectedFile, parseExcelFile }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(reset());
  }, [dispatch]);

  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <Title level={4}>Déposez votre fichier</Title>
      <Dragger
        className="upload-dragger"
        beforeUpload={file => {
          const isExcel =
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel';

          if (!isExcel) {
            return false;
          }

          setSelectedFile(file);
          parseExcelFile(file);

          return false; // empêcher l'upload auto
        }}
        accept=".xls,.xlsx"
        showUploadList={false}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Cliquez ou glissez-déposez un fichier Excel ici</p>
        <p className="ant-upload-hint">Format accepté: XLS, XLSX</p>
      </Dragger>
      {selectedFile && (
        <Alert
          message={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>Fichier sélectionné : {selectedFile.name}</span>
              <Button type="text" icon={<DeleteOutlined />} danger onClick={() => setSelectedFile(null)} />
            </div>
          }
          type="success"
          showIcon
          style={{ marginTop: 16, borderRadius: '4px' }}
        />
      )}
    </div>
  );
};

export default FileUpload;
